export const adminInputCls =
  "w-full border border-white/10 bg-charcoal px-4 py-3 text-sm text-white placeholder:text-neutral-600 transition-colors duration-300 focus:border-gold/60 focus:outline-none";

export const adminBtnCls =
  "flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.1em] text-neutral-300 transition-colors duration-300 hover:border-gold hover:text-gold disabled:opacity-40";

export const adminGoldBtnCls =
  "flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 text-xs font-black uppercase tracking-[0.12em] text-ink transition-colors duration-300 hover:bg-golddark disabled:opacity-60";

export const adminTabCls = (active: boolean) =>
  `shrink-0 rounded-full border px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.12em] transition-colors duration-300 ${
    active
      ? "border-gold bg-gold text-ink"
      : "border-white/15 text-neutral-400 hover:border-gold/50 hover:text-gold"
  }`;
